<template>
  <section class="p-8 max-mobile:py-4 max-mobile:px-2 scroll-mt-28">
    <RegistrationStepHeading
      :headline="`4. ${$t('dbc-headline-activation')}`"
      :showChangeButton="false"
    />

    <ol class="c-activation-ordered-list">
      <li v-html="firstMessage"></li>
      <li v-html="$t('dbc-text-activation-sepa-2')"></li>
    </ol>

    <DbcBanner
      class="w-2/5 my-xs max-tablet:w-full"
      :severity="'info'"
      :message="$t('dbc-text-activation-hint')"
    />

    <div class="c-activation-links">
      <NuxtLink
        @click="trackEvent('SEPA nicht-DACH', 'Klick Anrufen-Button')"
        class="dbc-gc-btn dbc-gc-btn--primary"
        :href="`tel:${servicePhoneNumber}`"
        >{{ $t('dbc-text-call') }}</NuxtLink
      >
      <button
        @click="clickLogin"
        class="dbc-gc-btn dbc-gc-btn--ghost c-registration-button"
      >
        {{ $t('dbc-text-continue-with-login') }}
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t, locale } = useI18n()
const configuration = inject('configuration') as Ref<Config | null>
const router = useRouter()
const mobileOs = useMobileOs()

const loginPath = locale.value === 'de' ? '/de/anmelden' : '/en/login'
const servicePhoneNumber = configuration.value
  ? configuration.value?.customerServicePhoneNumber.toString()
  : ''

const firstMessage = t('dbc-text-activation-sepa-1').replace(
  '[placeholder]',
  servicePhoneNumber.toString()
)

onMounted(() => {
  if (process.client) {
    window.scrollTo(0, 1)
  }

  trackEvent('SEPA nicht-DACH', 'manuelle Verifizierung angezeigt')
})

function clickLogin() {
  trackEvent('SEPA nicht-DACH', 'Klick Login-Button')
  if (mobileOs.value !== '') {
    //navigate to app login
    postWebviewMessage('registrationSuccess', {})
  } else {
    router.push({ path: loginPath })
  }
}
</script>
